module.exports = __webpack_public_path__ + "static/media/tcup-summary-background.89b460f1.svg";